if (!customElements.get('custom-popup-waitlist')) {
  customElements.define('custom-popup-waitlist', class CustomPopupWaitlist extends Popup {
    constructor()
    {
      super();

      this.donorId = null;
      this.motCategory = null;

      this.terms = this.querySelector('[name="terms"]');
      this.terms.addEventListener('change', e => {
        this.update()
      });

      this.submit = this.querySelector('.popup-waitlist-submit');
      this.submit.addEventListener('click', e => {
        e.preventDefault();

        if (this.submit.classList.contains('loading') || this.submit.classList.contains('disabled')) {
          return;
        }

        this.submit.classList.add('loading');
        this.querySelector('.popup-waitlist-error').classList.add('hidden');

        const motCategories = this.motCategory ? [this.motCategory] : [];

        app.waitlist.add(this.donorId, motCategories)
          .then(() => this.close())
          .catch(err => this.querySelector('.popup-waitlist-error').classList.remove('hidden') && console.error(err))
          .finally(() => this.submit.classList.remove('loading'));
      });
    }

    open(donorId, variantId, variantTitle, variantDescription, quantity)
    {
      super.open();

      this.donorId = donorId;
      this.motCategory = this.parseMotCategory(variantTitle);

      this.querySelector('.popup-waitlist-variant--title').textContent = variantTitle;
      this.querySelector('.popup-waitlist-variant--description').textContent = variantDescription;
      this.querySelector('.popup-waitlist-error').classList.add('hidden');
      this.update();
    }

    parseMotCategory(variantTitle)
    {
      const match = variantTitle && variantTitle.match(/MOT(\d+)/i);
      return match ? parseInt(match[1]) : null;
    }

    update ()
    {
      const acceptedTerms = this.terms.checked;

      if (acceptedTerms) {
        this.submit.disabled = false;
        this.submit.classList.remove('disabled');
      } else {
        this.submit.disabled = true;
        this.submit.classList.add('disabled');
      }
    }
  });
}
